<template>
  <div class="invoice-single">
    <template v-if="invoice && authorized">
      <print-header class="d-none d-print-block" :invoice="invoice" />
      <b-row class="d-print-none">
        <b-col :xl="6">
          <h1 class="page-title section-title">
            {{ invoice.reference }}
            <span class="subtitle"
              >- {{ invoice.stage_human | invoiceStageDisplay }}</span
            >
          </h1>
        </b-col>
      </b-row>
      <b-row>
        <b-col :xl="6">
          <invoice-info :invoice="invoice" />
        </b-col>
        <b-col :xl="5" :offset-xl="1" class="d-print-none">
          <containers-widget
            :containerIds="splitContainers"
            :invoiceShippingData="invoice.shipping_data"
            :token="token"
          ></containers-widget>
          <invoice-documents :invoice="invoice" />
        </b-col>
      </b-row>
    </template>
    <template v-else-if="!authorized">
      <b-row>
        <b-col
          :sm="12"
          class="d-flex flex-column justify-content-center unauthorized"
        >
          <p class="lead text-center">
            {{ $t('public.invoices.unauthorized') }}
          </p>
        </b-col>
      </b-row>
    </template>
    <loader v-else :height="500" />
  </div>
</template>
<script>
import InvoiceInfo from '@/components/invoices/Info'
import InvoiceDocuments from '@/components/invoices/Documents'
import PrintHeader from '@/components/invoices/PrintHeader'
import Loader from '@/components/common/Loader'
import ContainersWidget from '@/components/invoices/ContainersWidget'
import userService from '@/services/user'
import invoiceService from '@/services/invoice'

export default {
  data() {
    return {
      invoice: null,
      authorized: true,
      token: null
    }
  },
  mounted() {
    document.title = `${this.invoice?.reference} + ' | Invoices | Drip Portal'`
    this.loadInvoice()
  },
  methods: {
    printInvoice() {
      window.print()
    },
    loadInvoice() {
      return userService
        .fetchAccessToken()
        .then((res1) => {
          this.token = res1.data.token
          return invoiceService.getInvoicesByToken(
            this.$route.params.id,
            this.$route.params.auth_token,
            res1.data.token
          )
        })
        .then((res2) => {
          this.invoice = res2.data
        })
        .catch((e) => {
          console.log('error' + e)
          this.authorized = false
        })
    }
  },
  computed: {
    splitContainers() {
      return this.invoice.container !== null
        ? this.invoice.container.split('/')
        : false
    }
  },
  components: {
    InvoiceInfo,
    InvoiceDocuments,
    Loader,
    PrintHeader,
    ContainersWidget
  }
}
</script>
<style lang="scss" scoped>
.unauthorized {
  height: 75vh;
  .lead {
    font-size: 1.5rem;
    font-weight: 300;
  }
}
</style>
